import { ComponentsModule } from '../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsLayoutRendererLibModule } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { TaskListPage } from './task-list';

@NgModule({
  declarations: [TaskListPage],
  imports: [
    ComponentsModule,
    SellionsLayoutRendererLibModule,
    IonicPageModule.forChild(TaskListPage),
  ],
})
export class TaskListModule {}



// WEBPACK FOOTER //
// ./src/modules/tasks/pages/task-list/task-list.module.ts